import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { GetWorkerVm } from 'api/management/get-worker.vm';
import { GetWorkersVm } from 'api/management/get-workers.vm';
import { getWorkers } from 'api/management/get-workers';

const WorkersPage = () => {
  const theme = useTheme();
  const [workers, setWorkers] = useState<GetWorkerVm[]>([]);
  const [loading, setLoading] = useState(false);
  const [nextOffset, setNextOffset] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchWorkers = (offset: string | null, reset: boolean = false) => {
    setLoading(true);

    getWorkers(offset || '', {
      success: (response: GetWorkersVm) => {
        setHasMore(response.nextOffset !== null && response.nextOffset !== '');
        setNextOffset(response.nextOffset);
        setWorkers((prevWorkers) => (reset ? response.objects : [...prevWorkers, ...response.objects]));
        setLoading(false);
      },
      error: (err) => {
        console.error('Falha ao obter operadores:', err);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchWorkers(null, true);
  }, []);

  const handleLoadMore = () => {
    if (!hasMore || !nextOffset) return;
    // Load more - append to existing workers (reset = false)
    fetchWorkers(nextOffset, false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
          Operadores
        </Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: theme.palette.grey[800] }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Username</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {workers.map((worker) => (
              <TableRow key={worker.id} hover>
                <TableCell>{worker.id}</TableCell>
                <TableCell>{worker.name}</TableCell>
                <TableCell>{worker.username}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        {loading ? (
          <CircularProgress />
        ) : hasMore ? (
          <Button variant="outlined" onClick={handleLoadMore} disabled={loading || !nextOffset}>
            Carregar mais
          </Button>
        ) : workers.length > 0 ? (
          <Typography variant="body2" color="textSecondary">
            Não existem mais operadores para carregar
          </Typography>
        ) : (
          <Typography variant="body2" color="textSecondary">
            Nenhum operador disponível
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default WorkersPage;
